const orderReducer = (state = { same: true }, action) => {
  return (action.type === 'UPDATE_ORDER') ? {
    ...state,
    ...action.payload
  } : state;
};

export default orderReducer;
